import React, { useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import Logo from "../../assets/assets/Nibss-Logo.png";

const Aside2 = (props) => {
  useEffect(() => {
    const getAnchors = document.getElementsByClassName("link");
    if (getAnchors && getAnchors.length !== 0) {
      for (const item of getAnchors) {
        item.addEventListener("click", function () {
          props.showMenu(false);
        });
      }
    }
  }, [props]);

  return (
    <div className="aside2">
      <div className="nav-left">
        <Link to="/">
          <div className="nav-left-logo">
            <img src={Logo} alt="nibss-logo" />
          </div>
        </Link>
      </div>
      <br />

      <NavLink to="/login" className="sign-in">
        <span>SIGN IN</span>
      </NavLink>

      <NavLink to="/sign-up" className="sign-in">
        <span>SIGN UP</span>
      </NavLink>
      <a href="#terms" className="link">
        <span>Terms and Conditions</span>
      </a>

      <a href="#scope-of-the-GTC" className="link">
        <span>Scope of the GTC</span>
      </a>

      <a href="#definition" className="link">
        <span>Definition</span>
      </a>

      <a href="#interpretation" className="link" data-testid="link">
        <span>Interpretation</span>
      </a>

      <a href="#industry-address-verification-platform" className="link">
        <span>Industry Address Verification Platform (IAV)</span>
      </a>

      <a href="#compliance" className="link">
        <span>Compliance</span>
      </a>

      <a href="#representations-and-warranties" className="link">
        <span>Representations and Warranties</span>
      </a>

      <a href="#force-majeure" className="link">
        <span>Force Majeure</span>
      </a>

      <a href="#confidentiality" className="link">
        <span>Confidentiality</span>
      </a>

      <a href="#obligation-to-cooperate" className="link">
        <span>Obligation to Cooperate</span>
      </a>

      <a href="#indemnity" className="link">
        <span>Indemnity</span>
      </a>

      <a href="#limitation-of-liability" className="link">
        <span>Limitation of Liability</span>
      </a>

      <a href="#privacy" className="link">
        <span>Privacy</span>
      </a>

      <a href="#no-third-party-rights" className="link">
        <span>No Third Party Rights</span>
      </a>

      <a href="#password-security" className="link">
        <span>Password Security</span>
      </a>

      <a href="#taxes" className="link">
        <span>Taxes</span>
      </a>

      <a href="#terms-of-payment" className="link">
        <span>Terms of payment</span>
      </a>

      <a href="#restricted-activities" className="link">
        <span>Restricted activities</span>
      </a>

      <a href="#grant-of-use" className="link">
        <span>Grant of Use</span>
      </a>

      <a href="#termination" className="link">
        <span>Termination</span>
      </a>

      <a href="#notices" className="link">
        <span>Notices</span>
      </a>

      <a href="#governing-law-and-dispute-resolution" className="link">
        <span>Governing Law and Dispute Resolution</span>
      </a>

      <a href="#parties-relationship" className="link">
        <span>Parties’ Relationship</span>
      </a>

      <a href="#severability" className="link">
        <span>Severability</span>
      </a>

      <a href="#entire-agreement" className="link">
        <span>Entire Agreement</span>
      </a>

      <a href="#conflict-of-agreements" className="link">
        <span>Conflict of Agreements</span>
      </a>

      <a href="#agreement-not-assignable" className="link">
        <span>Agreement Not Assignable</span>
      </a>

      <a href="#anti-bribery-corruption-and-terrorism" className="link">
        <span>Anti-Bribery, Corruption and Terrorism</span>
      </a>

      <a href="#personal-data-processing-and-protection" className="link">
        <span>Personal Data Processing and Protection</span>
      </a>

      <a href="#indemnity" className="link">
        <span>Indemnity</span>
      </a>

      <a href="#release-of-NIBSS" className="link">
        <span>Release of NIBSS</span>
      </a>
    </div>
  );
};

export default Aside2;
